// @flow
import { getMessageBus } from '../apis'
import topics from '../apis/topics'
import { getDeviceInfo } from '@sitebase/device-detector'
import { WIDGET_ID, IFRAME_SOURCE_ID } from '../constants'

type logoutCallbackType = () => void

type LoginStatePayloadType = {
  isLoggedIn: boolean,
  cust: Object,
  data: Object,
}

export function waitForLogin(): Promise<void> {
  return new Promise((resolve, reject) => {
    const deviceInfo = getDeviceInfo()
    const messageBus = getMessageBus()
    const initialHref = global.location.href
    let loginToken
    let loginFlowToken
    let loginSessionToken
    let isLoggedIn
    let navigationPageToken

    if (!messageBus) {
      return reject(Error(`${WIDGET_ID}: No MessageBus available in loginHandler`))
    }

    const unsubscribe = () => {
      messageBus.unsubscribe(loginToken)
      messageBus.unsubscribe(loginFlowToken)
      messageBus.unsubscribe(loginSessionToken)
      if (navigationPageToken) {
        messageBus.unsubscribe(navigationPageToken)
      }
    }

    loginToken = messageBus.subscribe(topics.LOGIN, (_: string, payload: LoginStatePayloadType) => {
      const currentHref = global.location.href
      if (currentHref !== initialHref) {
        unsubscribe()
        reject(new Error(`${WIDGET_ID}: Login popup dismissed by navigation`))
      }

      if (!payload.isLoggedIn) {
        openModalLogin()

        if (deviceInfo.isNative) {
          // this case can happen in native when the user closes modal login and goes to other page
          navigationPageToken = messageBus.subscribe(topics.PAGE_CHANGE, () => {
            if (location.hash !== `#${IFRAME_SOURCE_ID}`) {
              unsubscribe()
              reject(new Error(`${WIDGET_ID}: User left the page`))
            }
          })
        }
      } else {
        unsubscribe()
        resolve()
      }
    })

    loginSessionToken = messageBus.subscribe(topics.LOGIN_SESSION, (_, action: { state: string }) => {
      isLoggedIn = action.state === 'LOGGED_IN' ? true : false
    })

    loginFlowToken = messageBus.subscribe(topics.LOGIN_STATE_CHANGED, (_, action: { state: string }) => {
      if (action.state === 'NONE') {
        unsubscribe()
        if (isLoggedIn) {
          resolve()
        } else {
          reject(new Error(`${WIDGET_ID}: Login popup dismissed by user`))
        }
      }
    })
  })
}

function openModalLogin() {
  if (getDeviceInfo().isNative) {
    window.location.href = 'nw-showlogin://'
  } else {
    const messageBus = getMessageBus()

    // open old login
    const loginElement = document.querySelector('#account-section section.account')
    loginElement && loginElement.classList.add('-expanded')

    // open new login
    messageBus && messageBus.publish(topics.START_NEW_LOGIN_PROCESS, {})
  }
}

export function listenToLogout(callback: logoutCallbackType): Promise<void> {
  return new Promise((resolve, reject) => {
    const messageBus = getMessageBus()
    if (!messageBus) {
      return reject(Error(`${WIDGET_ID}: No MessageBus available in listenToLogout`))
    }
    const logoutToken = messageBus.subscribe(topics.LOGIN, (_: string, payload: LoginStatePayloadType) => {
      const { isLoggedIn } = payload
      if (!isLoggedIn) {
        messageBus.unsubscribe(logoutToken)
        callback()
      }
      resolve()
    })
  })
}
